import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import OutletRouteAdmin from "../Components/OutletRouteAdmin";
import SuperadminDashboard from "../Components/SchoolAdmin/SuperAdmin/SuperDashboard";
import AdminViewTheme from "Components/SchoolAdmin/SuperAdmin/AdminViewTheme";
import DistrictViewTheme from "Components/SchoolAdmin/SuperAdmin/DistrictViewTheme";
import StateViewList from "Components/SchoolAdmin/SuperAdmin/StateViewList";
import SuperViewTheme from "Components/SchoolAdmin/SuperAdmin/stateViewSpecific";
import StateAdminViewTheme from "Components/SchoolAdmin/SuperAdmin/StateAdminViewTheme";
import LevelTwoDashboard from "Components/SchoolAdmin/SuperAdmin/LevelTwoDashboard";
import CollaborationView from "Components/SchoolAdmin/SuperAdmin/CollaborationView";
import AdminCollaborationView from "Components/SchoolAdmin/SuperAdmin/AdminCollaborationView";
import DelhiStateWiseDashboard from "../Components/SchoolAdmin/SuperAdmin/DelhiStateWiseDashboard";
import UttarPradeshStateWiseDashboard from "../Components/SchoolAdmin/SuperAdmin/UttarPradeshStateWiseDashboard copy";
import AdminLoginModel from "Components/Authentication/AdminLoginModel";
import RasActivitiesList from "../Components/SchoolAdmin/RasActivitiesList";
import RasActivitiesForm from "../Components/SchoolAdmin/RasActivitiesForm";
import EnvironmentDayDashboard from "../Components/SchoolAdmin/SuperAdmin/EnvironmentDayDashboard";
import ActivityReportSchools from "../Components/SchoolAdmin/SuperAdmin/ActivityReportSchools";
import ThemesAnalyticsDashboard from "../Components/SchoolAdmin/SuperAdmin/ThemesAnalyticsDashboard";
import ThemeDeepDive from "../Components/SchoolAdmin/SuperAdmin/ThemeDeepDive";
import StateThemesAnalyticsDashboard from "../Components/SchoolAdmin/SuperAdmin/StateThemesAnalyticsDashboard";
import StateThemeDeepDive from "../Components/SchoolAdmin/SuperAdmin/StateThemeDeepDive";
import SwachhataDashboard from "../Components/SchoolAdmin/SuperAdmin/SwachhataDashboard";
import SwmReport from "../Components/SchoolAdmin/SuperAdmin/SwmReport";
import EWasteDashboard from "../Components/SchoolAdmin/SuperAdmin/EWasteDashboard";
import Sc6Report from "../Components/SchoolAdmin/SuperAdmin/Sc6Report";
import BricsReport from "../Components/SchoolAdmin/SuperAdmin/BricsReport";
import DailyReport from "Pages/DailyReport";
import DailyReport2 from "Pages/DailyReport2";
import DailyReportDistrict from "Pages/DailyReportDistrict";
import FloraQRBasedevents from "Pages/FloraQRBasedevents";
import FloraQRBasedeventsAgeWise from "Pages/FloraQRBasedeventsAgeWise";
import DailyReport3 from "Pages/DailyReport3";
import DailyReport4 from "Pages/DailyReport4";
import Ekpedcentraladmin from "Components/SchoolAdmin/SuperAdmin/ekpedmaakenaamCentralAdmin";
import StateViewTrees from "Components/SchoolAdmin/SuperAdmin/StateViewTrees";
import Ekpedmaakenaam from "Components/SchoolAdmin/SuperAdmin/Ekpedmaakenaam";
import EkpedmaakenaamAdmin from "Components/SchoolAdmin/SuperAdmin/ekpedmaakenaamCentralAdmin";
import DistrictViewTrees from "Components/SchoolAdmin/SuperAdmin/DistrictViewTrees";
import AdminViewTabletrees from "Components/SchoolAdmin/SuperAdmin/schoolListTrees";
import ParticipantList from "Components/SchoolAdmin/SuperAdmin/participantList";
import ViewSchools from "Components/SchoolAdmin/SuperAdmin/ViewSchools";
import ViewSchoolsWithNotifications from "Components/SchoolAdmin/SuperAdmin/ViewSchoolsWithNotifications";
import DistrictWise from "Components/SchoolAdmin/SuperAdmin/DistrictWise";
import RasActivityAdminPage from "../Components/SchoolAdmin/RasActivityAdminPage";
import RoleGuard from "../Components/RoleGuard";
import HeaderAdmin from "../Components/HeaderAdmin";
import Footer from "../Components/Footer";

// Wrapper: sends state admins (role 4) to their dedicated state dashboard
function ThemesDashboardRouter() {
  const userData = useSelector(state => state.auth.user);
  if (userData?.role === 4) {
    return <Navigate to="/admin/state/themes-analysis" replace />;
  }
  return <ThemesAnalyticsDashboard />;
}

// Wrapper: sends state admins (role 4) trying to access central deep dive to state deep dive
function ThemeDeepDiveRouter() {
  const userData = useSelector(state => state.auth.user);
  const { themeName } = useParams();
  if (userData?.role === 4) {
    return <Navigate to={`/admin/state/themes-analytics/theme/${encodeURIComponent(themeName)}`} replace />;
  }
  return <ThemeDeepDive />;
}

function AdminRoutingPage() {

    const userData = useSelector(state => state.auth.user);
    console.log('inside school routinggggggggggggggggggggggggggggggggg', userData);

    return (
        <>
            {/* <Router> */}
            <Routes>



                <Route path="/school-list-state" element={<DailyReport4 />} />
                <Route path="/daily-report-event-wise" element={<DailyReport2 />} />
                <Route path="/daily-report-lang-wise" element={<DailyReport3 />} />
                 <Route path="/Ekpedmaakenaam" element={<RoleGuard allowedRoles={[4]}><Ekpedmaakenaam /></RoleGuard>}/>
                 <Route path="/Ekpedmaakenaamadmin" element={<RoleGuard allowedRoles={[1]}><EkpedmaakenaamAdmin /></RoleGuard>}/>
                <Route path="view-district-trees" element={<DistrictViewTrees />} />
                <Route path="view-state-trees" element={<StateViewTrees />} />
                <Route path="ekpedmaakenaam-school-state" element={<AdminViewTabletrees/>} />
                <Route path="ekped-participants" element={<ParticipantList />} />
                <Route path="/ekpedcentraladmin" element={<RoleGuard allowedRoles={[1]}><Ekpedcentraladmin /></RoleGuard>}/>
                <Route path="/view-schools" element={<ViewSchools />} />
                <Route path="/view-schools-notifications" element={<ViewSchoolsWithNotifications />} />
                <Route path="/Ekpedmaakenaamadmin/district-wise" element={<RoleGuard allowedRoles={[1]}><DistrictWise /></RoleGuard>}/>
                                
                    {/* Publicly accessible routes */}
                    {/* <Route element={<OutletRoutePublic />}> */}
                    {/* <Route index element={<SuperadminDashboard />} /> */}
                    <Route path="/daily-report" element={<DailyReport />} />
                    <Route path="/daily-report-district/:stateName" element={<DailyReportDistrict />} />
                    <Route path="/daily-report-FloraQR" element={<FloraQRBasedevents />} />
                    <Route path="/daily-report-FloraQR-AgeWise" element={<FloraQRBasedeventsAgeWise />} />

                    {/* </Route> */}

                    {/* Public admin login route */}
                    <Route
                        path="/admin/login"
                        element={
                            <>
                                <HeaderAdmin />
                                <AdminLoginModel />
                                <Footer />
                            </>
                        }
                    />

                    {/* Protected admin routes */}
                    <Route path="/admin" element={<RoleGuard allowedRoles={[1, 4]}><OutletRouteAdmin /></RoleGuard>}>
                        <Route index element={<SuperadminDashboard />} />
                        <Route path="admin" element={<SuperadminDashboard />} />
                        <Route path="level-2" element={<LevelTwoDashboard />} />
                        <Route path="state-level" element={<DelhiStateWiseDashboard />} />
                        <Route path="state-level-Uttar-Pradesh" element={<UttarPradeshStateWiseDashboard />} />
                        <Route path="view" element={<AdminViewTheme />} />
                        <Route path="view-district" element={<DistrictViewTheme />} />
                        <Route path="view-state-list" element={<StateViewList />} />
                        <Route path="state-view-specific" element={<SuperViewTheme />} />
                        <Route path="view-state" element={<StateAdminViewTheme />} />
                        <Route path="collaboration" element={<CollaborationView />} />
                        <Route path="admin-collaboration" element={<AdminCollaborationView />} />
                        {/* Ras Activity Admin Panel */}
                        <Route path="ras-activities" element={<RasActivitiesList />} />
                        <Route path="ras-activities/new" element={<RasActivitiesForm />} />
                        <Route path="ras-activities/edit/:id" element={<RasActivitiesForm />} />
                        <Route path="environment-day-dashboard" element={<EnvironmentDayDashboard />} />
                        <Route path="activity-report-schools" element={<ActivityReportSchools />} />
                        <Route path="themes-analytics" element={<ThemesDashboardRouter />} />
                        <Route path="themes-analytics/theme/:themeName" element={<ThemeDeepDiveRouter />} />
                        <Route path="state/themes-analysis" element={<StateThemesAnalyticsDashboard />} />
                        <Route path="state/themes-analytics/theme/:themeName" element={<StateThemeDeepDive />} />
                        {/* Swachhata Hi Seva: SWM Drive — participation + quiz analytics (role 4 state-locked server-side) */}
                        <Route path="swachhata-hi-seva" element={<SwachhataDashboard />} />
                        {/* Detailed Solid Waste Management report: every question, state/district-wise, Excel + PDF */}
                        <Route path="swm-report" element={<SwmReport />} />
                        {/* E-Waste Collection Drive — school reports (role 4 state-locked server-side) */}
                        <Route path="e-waste-drive" element={<EWasteDashboard />} />
                        {/* Special Campaign 6 (E-Waste, 28.10.2026) — State/UT/AB → district → block → school report (role 4 state-locked server-side) */}
                        <Route path="special-campaign-6-report" element={<Sc6Report />} />
                        <Route path="brics-report" element={<BricsReport />} />
                       
                    </Route>
                    <Route path="/ras-activity-admin" element={<RoleGuard allowedRoles={[1, 4]}><RasActivityAdminPage /></RoleGuard>} />
                    {userData?.role === 4 && (
                        <><Route path="/school/*" element={<Navigate to="/admin" replace />} />
                            <Route path="/faculty/*" element={<Navigate to="/admin" replace />} /></>
                    )}
            </Routes>
            {/* </Router> */}
        </>
    );
}

export default AdminRoutingPage;
